<template>
    <div class="base-form-div">
        <el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="父节点" prop="pid">
                <el-input :disabled="true" v-model="parentName"></el-input>
            </el-form-item>

            <el-form-item label="节点名称" prop="name">
                <el-input placeholder="请输入节点名称" v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="序号" prop="sort">
                <!-- <el-input placeholder="请输入序号" v-model="ruleForm.sort"></el-input> -->
                <el-input-number v-model="ruleForm.sort" controls-position="right" :min="0"></el-input-number>
            </el-form-item>
            <div class="form-bottom">
                <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">修改</el-button>
                <el-button class="base-button" size="mini" @click="resetForm('ruleForm')">重置</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import { getDeviceGroup ,updateDeviceGroup} from "@/api/device/index.js"
export default {
    props: ["subData"],
    data() {
        return {
            id:undefined,
            node:undefined,
            parentName:undefined,
            ruleForm: {
                parentId: "",
                name: "",
                sort: ""
            },
            rules: {
                name: [
                    { required: true, message: "请输入节点名称", trigger: "blur" },
                    {
                        min: 2,
                        max: 50,
                        message: "长度在 2 到 50 个字符",
                        trigger: "blur",
                    },
                ],
                sort: [
                    { required: true, message: "请输入节点序号", trigger: "change" },
                ]
            },
        };
    },
    methods: {
        submitForm(formName) {
            console.log(this.ruleForm);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    updateDeviceGroup(this.ruleForm).then(() => {
                        this.$message({
                            message: "修改成功",
                            type: "success",
                        });
                        this.$bus.$emit("card-list");
                        this.$bus.$emit("card-list-m");
                        this.$parent.close();
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        async initPids() {
            var res = await getDeviceGroup({id:this.id});
            this.node=res.result;
            this.ruleForm=this.node;
  
            //查询父节点
            var parent= await getDeviceGroup({id:this.node.parentId});
            this.parentName=parent.result.name;
            
        },
    },
    created() {
        this.id = this.subData.model.split("_")[1];
        this.initPids();
    },
    mounted() { },
};
</script>
<style>
.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}
</style>